module.exports = "<p>info-popover works!</p>\n"